import { faMinus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { observe } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Prompt, withRouter } from 'react-router';
import { Button, Col, FormGroup, Input, Label, Row } from 'reactstrap';
import ButtonRow from 'src/Components/ButtonRow';
import EInput, { EButton } from 'src/Components/EInput';
import WellFooter from 'src/Components/Footer/WellFooter';
import { IWellCloseReview } from 'src/Interfaces/WellInterface';
import TenantStore from 'src/Stores/Tenant/TenantStore';
import { WellsStore } from 'src/Stores/Wells/WellsStore';
import WorkflowHeader from '../../WorkflowHeader';
import WellCloseButton from '../WellCloseButton';
import WellRevertCloseButton from '../WellRevertCloseButton';


const editableBlueStyle = {backgroundColor: '#DEEFF5'};

@inject('stores')
@observer
class WellVolumeAccounting extends React.Component {
    public props: any;
    private WellsStore: WellsStore; 
    private TenantStore: TenantStore;
    private wellReviewDisposer: any;
    public state = {
        editStartingBaseOil: false,
        isDirty: false,
        wellCloseReview: undefined as unknown as IWellCloseReview,
    };

    constructor(props: any) {
        super(props);
        this.WellsStore = props.stores.WellsStore;
        this.TenantStore = props.stores.TenantStore;
    }

    public componentDidMount() {
        this.createObservers();
        if (this.WellsStore.well) {
            this.WellsStore.getWellCloseReview();
        } else {
            this.WellsStore.getWellDetails(this.props.match.params.wellId)
                .then(() => {
                    this.WellsStore.getWellCloseReview();
                });
        }
    }

    public componentWillUnmount() {
        this.wellReviewDisposer();
    }

    private createObservers() {
        this.wellReviewDisposer = observe(this.WellsStore, 'wellCloseReview', change => {
            this.setState({
                wellCloseReview: change.newValue
            });
        });
    }

    public handleLocalOverride = (event: any) => {
        switch (event.target.name) {
            case 'startingBaseOilUserOverride':
            {
                this.setState({
                    editStartingBaseOil: !this.state.editStartingBaseOil
                });
            }
        }
        
    }

    private handleInputChange = (event: any) => {
        const wellCloseReview = this.state.wellCloseReview;
        if (Number.isNaN(Number(event.target.value))) {
            return;
        }
        
        wellCloseReview.volumeAccounting[event.target.name] = Math.round(Number(event.target.value));
        
        this.WellsStore.updateWellCloseVolumes(wellCloseReview);
        this.setState({
            isDirty: true,
            wellCloseReview
        });
    }

    private updateWellCloseReview = () => {
        this.WellsStore.saveWellCloseReview(this.state.wellCloseReview)
            .then(data => {
                if (data) {
                    this.setState({isDirty: false});
                }
            });
    }

    private buttonNavigation = (event: any) => {
        const $target = event.target;
        if ( $target.name === 'previousButton' ) {
            this.props.history.push('/well/' + this.props.match.params.wellId + '/wellclose/intervalcostreview');
        } else {
            this.props.history.push('/well/' + this.props.match.params.wellId + '/wellclose/recapremarksreview');
        }
    }

    public render() {
        const wellCloseReview = this.state.wellCloseReview;
        if (wellCloseReview === undefined) {
            return <div>
                <WorkflowHeader workflowHeaderItems={this.props.workflowHeaderItems}/>
            </div>;
        }
        const volumeAccounting = wellCloseReview.volumeAccounting;
        return (
            <div className="VolumeAccounting">
                <Prompt when={this.state.isDirty} message={"Changes have been made.\n\nPress Cancel then Press Save OR Press OK to continue without saving."} />
                <WorkflowHeader workflowHeaderItems={this.props.workflowHeaderItems} isInventoryReport={false}/>
                <Row className="VolumeAccountColumns">
                    <Col md="3" className="baseOil">
                        <h5>Final Base Oil Acctg (gal)</h5>
                        <FormGroup>
                            <Label>
                                <Input
                                    type="checkbox"
                                    name="startingBaseOilUserOverride"
                                    id="startingBaseOilUserOverride"
                                    checked={this.state.editStartingBaseOil}
                                    onChange={this.handleLocalOverride}
                                />
                                Starting Base Oil
                            </Label>
                            <EInput
                                style={editableBlueStyle}
                                type="text"
                                name="startingBaseOil"
                                id="startingBaseOil"
                                value={volumeAccounting.startingBaseOil}
                                onChange={this.handleInputChange}
                                disabled={!this.state.editStartingBaseOil}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Base Oil Received</Label>
                            <EInput
                                type="text"
                                name="baseOilReceived"
                                id="baseOilReceived"
                                value={volumeAccounting.baseOilReceived}
                                onChange={this.handleInputChange}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Ending Base Oil</Label>
                            <EInput
                                type="text"
                                name="endingBaseOil"
                                id="endingBaseOil"
                                value={volumeAccounting.endingBaseOil}
                                onChange={this.handleInputChange}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Base Oil Used</Label>
                            <EInput
                                type="text"
                                name="baseOilUsed"
                                id="baseOilUsed"
                                value={volumeAccounting.baseOilUsed}
                                disabled={true}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Cum Base Oil Used TOTAL: Well</Label>
                            <EInput
                                type="text"
                                name="cumBaseOilUsed"
                                id="cumBaseOilUsed"
                                value={volumeAccounting.cumBaseOilUsed}
                                disabled={true}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="3" className="additionsBbbls">
                        <h5>Final Additions (bbls)</h5>
                        <FormGroup>
                            <Label>Base Oil Used</Label>
                            <EInput
                                type="text"
                                name="baseOilUsed"
                                id="baseOilUsed"
                                value={volumeAccounting.baseOil}
                                disabled={true}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Water</Label>
                            <EInput
                                type="text"
                                name="water"
                                id="water"
                                value={volumeAccounting.water}
                                onChange={this.handleInputChange}
                                
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>
                                Chemical Additions
                            </Label>
                            <EInput
                                type="text"
                                name="chemicalAdditions"
                                id="chemicalAdditions"
                                value={volumeAccounting.chemicalAdditions}
                                onChange={this.handleInputChange}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Slurry</Label>
                            <EInput
                                type="text"
                                name="slurry"
                                id="slurry"
                                value={volumeAccounting.slurry}
                                onChange={this.handleInputChange}
                                
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Water Flow</Label>
                            <EInput
                                type="text"
                                name="waterFlow"
                                id="waterFlow"
                                value={volumeAccounting.waterFlow}
                                onChange={this.handleInputChange}
                                
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Other Additions</Label>
                            <EInput
                                type="text"
                                name="otherAdditions"
                                id="otherAdditions"
                                value={volumeAccounting.otherAdditions}
                                onChange={this.handleInputChange}
                                
                            />
                        </FormGroup>
                        {/* Removed MUD-2997
                        <FormGroup>
                            <Label>New Hole Vol Built</Label>
                            <EInput
                                type="text"
                                name="newHoleVolumeAdjustment"
                                id="newHoleVolumeAdjustment"
                                value={volumeAccounting.newHoleVolume}
                                disabled={true}
                            />
                        </FormGroup> */}
                        <FormGroup>
                            <Label>Total Vol Additions</Label>
                            <EInput
                                type="text"
                                name="totalAdditions"
                                id="totalAdditions"
                                data-validation="decimal"
                                value={volumeAccounting.totalAdditions}
                                disabled={true}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="3" className="lossesBbls">
                        <h5>Final Losses (bbls)</h5>
                        <FormGroup>
                            <Label>Loss to Surface</Label>
                            <EInput
                                type="text"
                                name="lossToSurface"
                                id="lossToSurface"
                                value={volumeAccounting.lossToSurface}
                                onChange={this.handleInputChange}
                                
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Loss to Formation</Label>
                            <EInput
                                type="text"
                                name="lossToFormation"
                                id="lossToFormation"
                                value={volumeAccounting.lossToFormation}
                                onChange={this.handleInputChange}
                                
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Solids Control</Label>
                            <EInput
                                type="text"
                                name="solidsControl"
                                id="solidsControl"
                                value={volumeAccounting.solidsControl}
                                onChange={this.handleInputChange}
                                
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Mud Left in Hole</Label>
                            <EInput
                                type="text"
                                name="mudLeftInHole"
                                id="mudLeftInHole"
                                value={volumeAccounting.mudLeftInHole}
                                onChange={this.handleInputChange}
                                
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Other Losses</Label>
                            <EInput
                                type="text"
                                name="otherLoss"
                                id="otherLoss"
                                value={volumeAccounting.otherLoss}
                                onChange={this.handleInputChange}
                                
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Total Vol Losses</Label>
                            <EInput
                                type="text"
                                name="totalLosses"
                                id="totalLosses"
                                value={volumeAccounting.totalLosses}
                                disabled={true}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="3" className="finalVolInfo">
                        <h5>Reconciliation Volume (bbls)</h5>
                        <Row>
                            <Col md="2" />
                            <Col md="10">
                                <FormGroup>
                                    <Label>                                    
                                        Final Test Volume
                                    </Label>
                                    <EInput
                                        type="text"
                                        name="finalTestVolume"
                                        id="finalTestVolume"
                                        value={volumeAccounting.finalTestVolume}
                                        onChange={this.handleInputChange}
                                        disabled={true}
                                        />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="2" className="d-flex align-items-center text-right">
                                <FontAwesomeIcon icon="plus" color={this.TenantStore.iconColor} />
                            </Col>
                            <Col md="10">
                                <FormGroup>
                                    <Label>Total Vol Additions</Label>
                                    <EInput
                                        type="text"
                                        name="totalAdditions"
                                        id="totalAdditionsRec"
                                        value={volumeAccounting.totalAdditions}
                                        disabled={true}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row> 
                            <Col md="2" className="d-flex align-items-center text-right">
                                <FontAwesomeIcon icon={faMinus} color={this.TenantStore.iconColor} />
                            </Col>
                            <Col md="10">
                                <FormGroup>
                                    <Label>
                                        Total Vol Losses
                                    </Label>
                                    <EInput
                                        type="text"
                                        name="externalStorage"
                                        id="externalStorage"
                                        value={volumeAccounting.totalLosses}
                                        disabled={true}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row> 
                            <Col md="2" className="d-flex align-items-center text-right">
                                <FontAwesomeIcon icon={faMinus} color={this.TenantStore.iconColor} />
                            </Col>
                            <Col md="10">
                                <FormGroup>
                                    <Label>
                                        Other Vol Transfered
                                    </Label>
                                    <EInput
                                        type="text"
                                        name="otherVolTransferred"
                                        id="otherVolTransferred"
                                        value={volumeAccounting.otherVolTransferred}
                                        onChange={this.handleInputChange}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row className="EqualsLine">
                            <Col md="2" className="d-flex align-items-center text-right">
                                <FontAwesomeIcon icon={faMinus} color={this.TenantStore.iconColor} />
                            </Col>
                            <Col md="10">
                                <FormGroup>
                                    <Label>
                                        Plant Vol Returned
                                    </Label>
                                    <EInput
                                        type="text"
                                        name="plantVolReturned"
                                        id="plantVolReturned"
                                        value={volumeAccounting.plantVolReturned}
                                        onChange={this.handleInputChange}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="2" className="d-flex align-items-center">
                                <FontAwesomeIcon icon="equals" color={this.TenantStore.iconColor} />
                            </Col>
                            <Col md="10">
                                <FormGroup>
                                    <Label>Reconciliation Factor</Label>
                                    <EInput
                                        type="text"
                                        name="reconciliationFactor"
                                        id="reconciliationFactor"
                                        value={volumeAccounting.reconciliationFactor}
                                        disabled={true}
                                        />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="2" className="d-flex align-items-center">
                                <FontAwesomeIcon icon="equals" color={this.TenantStore.iconColor} />
                            </Col>
                            <Col md="10">
                                <FormGroup>
                                    <Label>Vol Owed To Plant</Label>
                                    <EInput
                                        type="text"
                                        name="volOwedToPlant"
                                        id="volOwedToPlant"
                                        value={volumeAccounting.volOwedToPlant}
                                        disabled={true}
                                        />
                                </FormGroup>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <ButtonRow>
                    <WellRevertCloseButton />
                    <WellCloseButton />
                    <Button className="secondary" name="previousButton" onClick={this.buttonNavigation}>Previous</Button>
                    { this.WellsStore.canUpdateWell() && <EButton color="primary" name="save" onClick={this.updateWellCloseReview}>Save</EButton>}
                    <Button className="secondary" name="nextButton" onClick={this.buttonNavigation}>Next</Button>
                    <WellFooter />
                </ButtonRow>
            </div>
        );
    }


}

export default withRouter(WellVolumeAccounting);


// WEBPACK FOOTER //
// ./src/Components/Main/WellWorkflow/WellClose/WellVolumeAccounting.tsx